import React from 'react';
import {Box, Paper, Typography} from '@mui/material';
import {Layout} from '../components/Layout';

export const Legal: React.FC = () => {
  return (
    <Layout>
      <Box sx={{maxWidth: 800, mx: 'auto'}}>
        <Typography variant="h4" component="h1" gutterBottom>
          Legal Notice
        </Typography>
        <Paper sx={{p: 3, mt: 2}}>
          <Typography variant="body1" component="div">
            <strong>Spectral World GmbH</strong>
            <br/>
            Imberstraße 10
            <br/>
            76227 Karlsruhe
          </Typography>

          <Typography variant="body1" component="div" sx={{mt: 3}}>
            Tel: 0721 / 976459 – 90
            <br/>
            E-Mail:{' '}
            <a href="mailto:info@spectralworld.io" style={{color: 'inherit'}}>
              info@spectralworld.io
            </a>
          </Typography>

          <Typography variant="body1" component="div" sx={{mt: 3}}>
            Geschäftsführung: Marco Kellmann
            <br/>
            Registergericht: Amtsgericht Mannheim, HRB 735658
            <br/>
            USt-ID: DE332160047
          </Typography>
        </Paper>
      </Box>
    </Layout>
  );
};
